import { render, staticRenderFns } from "./NiceAdminDashboard.vue?vue&type=template&id=ccf83b5e&scoped=true"
import script from "./NiceAdminDashboard.vue?vue&type=script&lang=js"
export * from "./NiceAdminDashboard.vue?vue&type=script&lang=js"
import style0 from "./NiceAdminDashboard.vue?vue&type=style&index=0&id=ccf83b5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccf83b5e",
  null
  
)

export default component.exports